<template>
	
</template>

<script>
import { urls } from '@js'

export default {
  created() {
    if (this.$route.name == 'rigister_init' || this.$route.name == 'rigister') {
      let URL = urls.landingUsaRegister
      let chennel = this.$route.query.channel
      let detail = this.$route.query.detail
      if (chennel && detail) {
        URL = URL + '?channel=' + chennel + '&detail=' + detail + ''
      }
      window.location.href = URL;
    }
  }
}
</script>


// WEBPACK FOOTER //
// loading.vue?474bfbb8